module.exports = __webpack_public_path__ + "img/B.cdc72673.jpg";